import Cookies from "js-cookie";

const CookieKeys = {
  // 模拟登陆 = 1
  cookie_insert_log: "cookie_insert_log",
  //用户名
  qlm_username: "qlm_username",
  //用户密码
  qlm_password: "qlm_password",
  //登录后返回的地址
  backUrl: "backUrl",
  //用户信息
  userInfo: "userInfo",
  //Token信息
  xAuthToken: "xAuthToken",
  //滑动验证信息
  accessCaptchaPermission: "accessCaptchaPermission",
  userAppMenu: "userAppMenu",
  userLeftMenuClick: "userLeftMenuClick",
  //设备id
  qlmVisitorId: "qlm_visitor_id",
};

export { CookieKeys, Cookies };
